import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { CategoryTiles } from '../CategoryTiles/CategoryTiles';
import { CategoryRooms } from '../CategoryRooms/CategoryRooms';
import { Error403Header } from '../Error403Header/Error403Header';
import { Error403Layout_viewer$key } from './__generated__/Error403Layout_viewer.graphql';

const viewerFragment = graphql`
    fragment Error403Layout_viewer on Viewer {
        ...CategoryTiles_viewer
    }
`;

type Props = {
    viewer: Error403Layout_viewer$key;
    content?: string;
};

export const Error403Layout: FC<Props> = ({ viewer: viewerRef, content }) => {
    const viewer = useFragment(viewerFragment, viewerRef);

    return (
        <>
            <Error403Header content={content} />
            <CategoryTiles viewer={viewer} showModules /> .
            <CategoryRooms />
        </>
    );
};
